<template>
  <div>
    <el-button @click="test">测试btn</el-button>
  </div>
</template>

<script>
export default {
  name: 'hello',
  data () {
    return {

    }
  },
    methods:{
        test:function () {
            this.$http.getData('logintest',()=>{},()=>{})
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
